<template>
  <div>
      <v-list>
        <v-list-tile @click.stop="navigateTo(defaultCalendarRouteName)">
          <v-list-tile-action>
            <v-icon>calendar_today</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Calendar
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click.stop="navigateTo(defaultCalendarRouteName)">
          <v-list-tile-action>
            <v-icon>person</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Staffing
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group
          prepend-icon="work"
          value="true"
        >
        <template slot="activator">
          <v-list-tile>
            <v-list-tile-title>
              HR
            </v-list-tile-title>
          </v-list-tile>
        </template>

          <v-list-tile @click.stop="navigateTo('hr')">
            <v-list-tile-action>
              <v-icon>people_outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Employees
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="navigateTo('resources')">
            <v-list-tile-action>
              <v-icon>library_books</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Resources
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="navigateTo('hrClients')">
            <v-list-tile-action>
              <v-icon>supervisor_account</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Client Users
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="navigateTo('hrClientBusinesses')">
            <v-list-tile-action>
              <v-icon>domain</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Locations
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click.stop="navigateTo('hrGeotags')">
            <v-list-tile-action>
              <v-icon>public</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Geotags
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click.stop="navigateTo('hrManagers')">
            <v-list-tile-action>
              <v-icon>device_hub</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Managers
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click.stop="navigateTo('reports')">
            <v-list-tile-action>
              <v-icon>table_chart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Reports
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="navigateTo('smsIndex')">
            <v-list-tile-action>
              <v-icon>phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              SMS
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-tile @click.stop="navigateTo('settingsIndex')">
          <v-list-tile-action>
            <v-icon>settings</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Settings
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('userAuth', [
      'user',
      'token'
    ]),
    ...mapGetters('userAuth', [
      'isLoggedIn',
      'defaultCalendarRouteName'
    ])
  },
  methods: {
  }
}
</script>

<style scoped>
  #sidebar a {
    color: black;
    text-decoration: none;
  }
</style>
